import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';

import { DispatchProperties } from '../../../../../redux/store';
import { getDTTPrompts, getTAPrompts } from '../../../../../redux/State/clientSlice/dataCollectionSlice';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';
import {
	DTTPromptsResponseProperties,
	TAPromptsResponseProperties,
} from '../../../../../redux/API/ClientAPIHelpers/calendarProperties';

export const useFetchDTTTargetHistory = (targetId: string) => {
	const { sessionId } = useParams();
	const dispatch = useDispatch<DispatchProperties>();
	const [loading, setLoading] = useState<boolean>(false);
	const [targetHistory, setTargetHistory] = useState<DTTPromptsResponseProperties[]>([]);

	const fetchHistory = useCallback(() => {
		if (!sessionId || !targetId) return;
		setLoading(true);
		dispatch(getDTTPrompts({ targetId, sessionId }))
			.then(unwrapResult)
			.then((response) => setTargetHistory(response))
			.catch(errorNormalizer)
			.finally(() => setLoading(false));
	}, [sessionId, targetId, dispatch]);

	return { loading, targetHistory, fetchHistory };
};

export const useFetchTATargetHistory = (targetId: string) => {
	const { sessionId } = useParams();
	const dispatch = useDispatch<DispatchProperties>();
	const [loading, setLoading] = useState<boolean>(false);
	const [targetHistory, setTargetHistory] = useState<TAPromptsResponseProperties[]>([]);

	const fetchHistory = useCallback(() => {
		if (!sessionId || !targetId) return;
		setLoading(true);
		dispatch(getTAPrompts({ targetId, sessionId }))
			.then(unwrapResult)
			.then((response) => setTargetHistory(response))
			.catch(errorNormalizer)
			.finally(() => setLoading(false));
	}, [sessionId, targetId, dispatch]);

	return { loading, targetHistory, fetchHistory };
};
